module.exports = __webpack_public_path__ + "static/media/success-icon.e2fd4117.svg";